module.exports = library_vue;